import { ITEM_TYPES } from '../../lib/items';
import { ClockItem } from './ClockItem';
import { MediaItem } from './MediaItem';
import { TextItem } from './TextItem';
import { WebPageItem } from './WebPageItem';

// One renderer per item type. Items of other types never reach rendering (see playableItems).
export const ITEM_RENDERERS = {
  [ITEM_TYPES.media]: MediaItem,
  [ITEM_TYPES.webPage]: WebPageItem,
  [ITEM_TYPES.text]: TextItem,
  [ITEM_TYPES.clock]: ClockItem,
};
